import { call, put, takeLatest } from "redux-saga/effects";
import { onPostAddToCart, onPostAddToCartError, onPostAddToCartSuccess } from "../Store/Slices/addToCartSlice";
import { decryptAES } from "../Common/Axios/encrypt";
import { callAddToCartPostApi } from "../Context/addToCartApi";


function* PostOrder({ payload }) {
  try {
    const postOrderResponse = yield call(callAddToCartPostApi, payload);

    if (postOrderResponse?.httpStatusCode === "201") {
      yield put(
        onPostAddToCartSuccess({
          postData: postOrderResponse.response,
          message: postOrderResponse.errorMessage,
          status_code: postOrderResponse.httpStatusCode,
        })
      );
    } else {
      yield put(
        onPostAddToCartError({
          data: postOrderResponse?.response,
          message:
            postOrderResponse?.errorMessage,
          status_code: postOrderResponse?.httpStatusCode,
        })
      );
    }
  } catch (error) {
    const errorData = process.env.REACT_APP_IS_E_E === "false" ? error?.response?.data : decryptAES(error?.response?.data);
    yield put(
      onPostAddToCartError({
        data: errorData || {},
        message: errorData?.ErrorMessage || errorData?.errorMessage,
        status_code: errorData?.HttpStatusCode || errorData?.httpStatusCode,
      })
    );
  }
}


export default function* AddToCartSaga() {
  yield takeLatest(onPostAddToCart.type, PostOrder);
}
